<nav #navigation aria-label="Fortschritt" class="ba-progress-nav ba-horizontal">
  <div class="ba-progress-steps">
    <ol aria-label="Bitte wählen Sie den gewünschten Schritt" class="ba-naventries">
      @for (item of ($items | async); track item) {
        @if (item.visible) {
          <li
            [id]="'NAV_' + item.id"
            [ngClass]="{
              'active': item.active,
              'disabled': item.disabled || !item.progressed,
              'progressed': item.progressed
              }"
            class="{{item.status}}">
            <!-- active -->
            @if (item.active) {
              <a [routerLink]="item.url" id="NAV_ACTIVE_ITEM" >
                <span class="ba-step-label ba-icon {{item.icon}}"></span>
                <span class="ba-step-title">{{item.label}}<span class="sr-only">(aktuelle Auswahl)</span></span>
              </a>
            }
            <!-- none active -->
            @if (!item.active && !item.disabled && item.progressed) {
              <a (click)="clickEvent.emit(item)"
                 [routerLink]="item.url">
                 <span class="ba-step-label ba-icon {{item.icon}}"></span>
                 <span class="ba-step-title">{{item.label}}
                    @if (item.status === 'done') {
                      <span class="sr-only">(abgeschlossen)</span>
                    }
                    @if (item.status === 'warning') {
                      <span class="sr-only">(Warnungen vorhanden)</span>
                    }
                    @if (item.status === 'error') {
                      <span class="sr-only">(Fehler vorhanden)</span>
                    }
                </span>
              </a>
            }
            <!-- disabled -->
            @if (item.disabled || !item.progressed) {
              <span>
                <span class="ba-step-label ba-icon {{item.icon}} text-muted"></span>
                <span class="ba-step-title text-muted">{{item.label}}
                  <span class="sr-only">(deaktiviert)</span>
                </span>
              </span>
            }
          </li>
        }
      }
    </ol>
    <a href="#" class="ba-toggle-progress" role="button">
      <span class="ba-progress-open ba-link-down">Alle Schritte anzeigen</span>
      <span class="ba-progress-close ba-link-up">Alle Schritte ausblenden</span>
    </a>
  </div>
</nav>
